const GSM_7BIT_CHARS =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ " +
  "!\"#¤%&'()*+,-./0123456789:;<=>?" +
  "ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§" +
  "¿abcdefghijklmnopqrstuvwxyzäöñüà" +
  "{}[]^~|\\€";

export function isGsmText(text: string): boolean {
  let ignoring = false;

  for (let i = 0; i < text.length; i++) {
    const c = text[i];

    if (c === "{") {
      ignoring = true;
      continue;
    }

    if (c === "}") {
      ignoring = false;
      continue;
    }

    if (ignoring) continue;

    if (!GSM_7BIT_CHARS.includes(c)) {
      return false;
    }
  }
  return true;
}

export function getSmsSegments(text: string, isUnicode: boolean): number {
  const charCount = text.length;

  if (isUnicode) {
    return charCount <= 70 ? 1 : Math.ceil(charCount / 67);
  } else {
    return charCount <= 160 ? 1 : Math.ceil(charCount / 153);
  }
}
export function getSmsCharCount(text: string) {
  const normalized = text.replace(/\n/g, "\r\n");

  return Array.from(normalized).length;
}
